import { UAParser } from 'ua-parser-js';
import semver from 'semver';

/**
 * @returns
 */
export function generateUUID() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
}

export async function loadMsgScript() {
  return new Promise((resolve, reject) => {
    if (document.getElementById('VhallBaseSDK')) {
      resolve(true);
      return;
    }
    let scriptEl = document.createElement('script');
    scriptEl.setAttribute('type', 'text/javascript');
    scriptEl.setAttribute('id', 'VhallBaseSDK');
    scriptEl.setAttribute('src', process.env.BASE_MESSAGE_URL + '?t=' + Date.now());
    document.head.appendChild(scriptEl);
    scriptEl.onload = () => {
      resolve(true);
    };
    // eslint-disable-next-line prefer-promise-reject-errors
    scriptEl.onerror = () => reject(false);
  });
}

export const systemProbe = function () {
  let result = Object.create(null);
  let uaResult = new UAParser().getResult();
  result.isTencent = (uaResult.ua.match(/mqqbrowser|qzone|qqbrowser|qq|micromessenger/i) || []).length > 0;
  result.browser = uaResult.browser?.name?.toLowerCase();
  result.browserVersion = uaResult.browser.version;
  result.os = uaResult.os?.name?.toLowerCase();
  result.osVersion = uaResult.os.version;
  result.platform =
    (
      uaResult.ua.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      ) || []
    ).length > 0
      ? 'mobile'
      : 'pc';
  // cv short for convert version.
  const cv = ov => semver.coerce(ov);

  // 基于 https://caniuse.com/#search=mediasource 2019-08-23日结果
  const judgeMSE = () => {
    window.semver = semver;

    // iOS safari 完全不支持
    if (result.os === 'ios' && result.browser.indexOf('safari')) {
      return false;
    }

    // chrome 小于23 完全不支持
    if (result.browser === 'chrome' && semver.lt(cv(result.browserVersion), cv(23))) {
      return false;
    }

    // firefox 42以下不支持
    if (result.browser === 'firefox' && semver.lt(cv(result.browserVersion), cv(42))) {
      return false;
    }

    // ie 11 以下不支持(11版本部分支持)
    if (result.browser === 'ie' && semver.lt(cv(result.browserVersion), cv(11))) {
      return false;
    }

    // 安卓4.4以下不支持
    if (result.os === 'android' && semver.lt(cv(result.osVersion), cv(4.4))) {
      return false;
    }

    // opera 15以下不支持
    if (result.browser === 'opera' && semver.lt(cv(result.browserVersion), cv(15))) {
      return false;
    }

    // opera mobile46以下不支持
    if (result.browser === 'opera mobile' && semver.lt(cv(result.browserVersion), cv(46))) {
      return false;
    }

    // opera mini 不支持
    if (result.browser === 'opera mini') {
      return false;
    }

    // 三星不支持
    if (result.browser.indexOf('samsung') >= 0) {
      return false;
    }

    // 如果window上都没有MediaSource不存在，不支持MSE
    if (typeof window !== 'undefined') {
      // 判断是否有mediaSource
      const existMediaSource = window.MediaSource || window.WebKitMediaSource;
      // 判断是否有SourceBuffer
      const sourceBuffer = window.SourceBuffer || window.WebKitSourceBuffer;
      // 判断sourceBuffer 是否有appendBuffer
      const validSourceBufferApi =
        (sourceBuffer &&
          sourceBuffer.prototype &&
          typeof sourceBuffer.prototype.appendBuffer === 'function' &&
          typeof sourceBuffer.prototype.remove === 'function') ||
        false;

      return existMediaSource && validSourceBufferApi;
    }

    return true;
  };
  result.supportMSE = judgeMSE();
  return result;
};

/**
 * 深拷贝
 * @param {*} obj 拷贝对象(object or array)
 * @param {*} cache 缓存数组
 */
export const deepCopy = (obj, cache = []) => {
  // typeof [] => 'object'
  // typeof {} => 'object'
  if (obj === null || typeof obj !== 'object') {
    return obj;
  }
  // 如果传入的对象与缓存的相等, 则递归结束, 这样防止循环
  /**
   * 类似下面这种
   * var a = {b:1}
   * a.c = a
   * 资料: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
   */
  const hit = cache.filter(c => c.original === obj)[0];
  if (hit) {
    return hit.copy;
  }

  const copy = Array.isArray(obj) ? [] : {};
  // 将copy首先放入cache, 因为我们需要在递归deepCopy的时候引用它
  cache.push({
    original: obj,
    copy
  });
  Object.keys(obj).forEach(key => {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
};

export const mixin = (target, MixinConstructor, ...args) => {
  let source = new MixinConstructor(...args);
  let names = Object.getOwnPropertyNames(MixinConstructor.prototype);
  for (let name of names) {
    let val = source[name];
    if (typeof val === 'function' && name !== 'constructor') {
      target[name] = val.bind(source);
    }
  }
};

export const removeArray = (arr, param) => {
  const index = arr.findIndex(item => item == param);
  arr.splice(index, 1);
  return arr;
};

export const isObject = obj => {
  return Object.prototype.toString.call(obj).toLowerCase() === '[object object]';
};

/**
 * url拼接
 * 示例：
 *  urljoin('https://test.com','/demo','index.html') => 'https://abc.com/demo/index.html'
 *  urljoin('//test.com','assets','main.css') => '//test.com/assets/main.css'
 * @param  {...string} paths 带拼接的路径数组
 * @returns
 */
export function urljoin(...paths) {
  if (Array.isArray(paths) && paths.length) {
    return paths.reduce((url, currentValue, idx) => {
      if (typeof currentValue === 'string') {
        // 去除两边空格，并去除最后面的斜杠(/)
        currentValue = currentValue.trim().replace(/\/*$/gi, '');
        if (idx === 0) {
          url = currentValue;
        } else {
          // 去除最前面的斜杠(/)
          currentValue = currentValue.replace(/^\/*/gi, '');
          if (currentValue) {
            url = `${url}/${currentValue}`;
          }
        }
      }
      return url;
    }, '');
  }
  return '';
}
